import React from 'react';
import { motion } from 'framer-motion';
export function TwentyOneDayPlan() {
  const weeks = [{
    number: '1',
    title: 'Limpieza y preparación',
    desc: 'Eliminamos lo que inflama, ordenamos tu despensa y empezamos a notar las primeras señales de calma.'
  }, {
    number: '2',
    title: 'Incorporación profunda',
    desc: 'Sumamos los alimentos y hábitos que verdaderamente desinflaman tu cuerpo.'
  }, {
    number: '3',
    title: 'Integración y hábito',
    desc: 'Consolidamos un estilo de vida sostenible que puedes mantener mucho después de los 21 días.'
  }];
  return <section className="w-full px-4 py-20 bg-cream" data-id="element-352">
      <div className="max-w-6xl mx-auto" data-id="element-353">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-354">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-ink mb-6" data-id="element-355">
            Un plan de 21 días pensado para que NO te quedes en la teoría
          </h2>
          <p className="text-lg md:text-xl text-ink/80 max-w-2xl mx-auto" data-id="element-356">
            Tres semanas guiadas, paso a paso, con menús, listas de compra y
            seguimiento.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-357">
          {weeks.map((week, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative bg-ivory p-8 rounded-3xl border border-taupe/10 hover:border-sage/30 transition-colors pt-12" data-id="element-358">
              <div className="absolute -top-6 left-8 w-12 h-12 bg-sage text-ivory rounded-full flex items-center justify-center font-serif text-2xl font-bold shadow-lg" data-id="element-359">
                {week.number}
              </div>
              <h3 className="text-xs font-bold tracking-widest text-taupe uppercase mb-3" data-id="element-360">
                Semana {week.number}
              </h3>
              <h4 className="text-2xl font-serif text-ink font-bold mb-4" data-id="element-361">
                {week.title}
              </h4>
              <p className="text-ink/80 leading-relaxed" data-id="element-362">{week.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}